import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Form, Row, Col } from "react-bootstrap";
import { SvgIcon } from '@mui/material';
import moment from 'moment';
import { sub } from 'date-fns';
import Ring from '../icons/ring.svg?react';
import { MARYLAND, VIRGIN_ISLANDS } from '../../../Helpers/Constants/States';
import { customValidators, object, string, array as yuparray, number as yupnumber, date, mixed } from '../../../Helpers/Validators/customValidators';
import BeneficiaryForm from "./BeneficiaryForm";
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import { SelectInput } from "../../../Helpers/Inputs";
import BackNext from '../../Common/SubComponents/BackNext';
import Age from '../../../Helpers/Dates/Age';

export default function Beneficiary(props) {
    const getNumberOfBeneficiaryOptions = (isZero) => {
        const options = [
            { value: 1, label: "1" },
            { value: 2, label: "2" },
        ];

        if (isZero) {
            options.unshift({ value: 0, label: "0" });
        }

        return options;
    }

    const state = props.fullFormState.steps.basicInfo.state;

    const [showBeneCountMessage, setShowBeneCountMessage] = useState(false)
    const [beneCountMessage, setBeneCountMessage] = useState("")
    const beneErrorMessage = useRef()
    var insuredAge = Age(props.fullFormState.steps.basicInfo.birthdate);
    const formMethods = useForm({
        resolver: yupResolver(Beneficiary.ValidationSchema(insuredAge, state)),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState,
    });

    const { handleSubmit, trigger, setValue } = formMethods;
    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
        trigger(field);
    };
    useEffect(() => {
        var form = { ...props.fullFormState };
        props.formState.beneficiaries.forEach((bene, index) => {
            if (form.steps.quoter.plan === "individualPremium" || form.steps.quoter.plan === "oneParentFamilyPremium") {
                form.steps.beneficiary.beneficiaries[index].selectPrimary = 'New Individual';
            } else {
                form.steps.beneficiary.beneficiaries[index].selectPrimary = 'Name Of Spouse';
            }
            if (bene.selectPrimary !== "New Individual") {
                const details = getBeneficiaryDetails(bene.selectPrimary);
                form.steps.beneficiary.beneficiaries[index].firstName = details.firstName;
                form.steps.beneficiary.beneficiaries[index].lastName = details.lastName;
                form.steps.beneficiary.beneficiaries[index].middleInitial = details.middleName;
                form.steps.beneficiary.beneficiaries[index].city = details.city;
                form.steps.beneficiary.beneficiaries[index].state = details.state;
                form.steps.beneficiary.beneficiaries[index].dateOfBirth = details.dateOfBirth;
                form.steps.beneficiary.beneficiaries[index].relationship = details.relationshipStatus;
            }
        });
        props.formState.contBeneficiaries.forEach((bene, index) => {
            if (bene.selectContingent !== "New Individual") {
                const details = getBeneficiaryDetails(bene.selectContingent);

                form.steps.beneficiary.contBeneficiaries[index].firstName = details.firstName;
                form.steps.beneficiary.contBeneficiaries[index].lastName = details.lastName;
                form.steps.beneficiary.contBeneficiaries[index].middleInitial = details.middleName;
                form.steps.beneficiary.contBeneficiaries[index].city = details.city;
                form.steps.beneficiary.contBeneficiaries[index].state = details.state;
                form.steps.beneficiary.contBeneficiaries[index].dateOfBirth = details.dateOfBirth;
                form.steps.beneficiary.contBeneficiaries[index].relationship = details.relationshipStatus;
            }
        });
        props.onMultiFieldChange(form);
        setValue(`beneficiaries`, form.steps.beneficiary.beneficiaries);
        setValue(`contBeneficiaries`, form.steps.beneficiary.contBeneficiaries);
    }, []);

    const getBeneficiaryDetails = (beneficiaryName) => {
        var form = { ...props.fullFormState };
        var firstName, middleName, lastName, city, state, dateOfBirth, relationshipStatus;
        if (beneficiaryName === "Name Of Spouse") {
            if (form.steps.spouseInfo) {
                firstName = form.steps.spouseInfo.firstName;
                middleName = form.steps.spouseInfo.middleInitial;
                lastName = form.steps.spouseInfo.lastName;
                dateOfBirth = form.steps.spouseInfo.birthdate;
                relationshipStatus = "Spouse";
                city = "";
                state = ""
            }
        }
        return { firstName, middleName, lastName, city, state, dateOfBirth, relationshipStatus }
    }

    const handleSelectContingentBeneficiary = (value, index) => {
        var form = { ...props.fullFormState };
        const { firstName, middleName, lastName, city, state, dateOfBirth, relationshipStatus } = getBeneficiaryDetails(value);

        form.steps.beneficiary.contBeneficiaries[index].selectContingent = value;
        form.steps.beneficiary.contBeneficiaries[index].firstName = firstName ? firstName : '';
        form.steps.beneficiary.contBeneficiaries[index].middleInitial = middleName ? middleName : '';
        form.steps.beneficiary.contBeneficiaries[index].lastName = lastName ? lastName : '';
        form.steps.beneficiary.contBeneficiaries[index].city = city ? city : '';
        form.steps.beneficiary.contBeneficiaries[index].state = state ? state : '';
        form.steps.beneficiary.contBeneficiaries[index].dateOfBirth = dateOfBirth ? dateOfBirth : null;
        form.steps.beneficiary.contBeneficiaries[index].relationship = relationshipStatus ? relationshipStatus : '';

        props.onMultiFieldChange(form);
        setValue(`contBeneficiaries`, form.steps.beneficiary.contBeneficiaries);
    }

    useEffect(() => {
        const numberOfPrimaryBeneficiaryForms = props.formState.numberOfPrimaryBeneficiary;
        const numberOfForms = props.formState.beneficiaries.length;

        const nullCount = [];
        if (numberOfPrimaryBeneficiaryForms > 0) {
            if (numberOfForms > numberOfPrimaryBeneficiaryForms) {
                for (let i = 0; i < numberOfForms - numberOfPrimaryBeneficiaryForms; i++) {
                    let nullForms = props.formState.beneficiaries.map((beneficiaryFormState, index) => {
                        if (Object.values(beneficiaryFormState).every(field => field === '')) {
                            return index;
                        }
                    })
                    if (nullForms.length > 0) {
                        nullForms = nullForms.filter((index) => index !== undefined);
                    }
                    if (nullForms.length === 0) {
                        props.formState.beneficiaries.map((beneficiaryFormState, index) => {
                            const arrayValues = Object.values(beneficiaryFormState)
                            nullCount[index] = arrayValues.filter(value => value === null || value === '').length;
                            return
                        })
                    }
                    if (nullCount.length > 0) {
                        const maxVlaue = Math.max(...nullCount);
                        nullForms = [nullCount.indexOf(maxVlaue)];

                        if (nullForms.length === 0) {
                            nullForms = [parseInt(numberOfPrimaryBeneficiaryForms)];
                        }
                    }
                    const selectedBene = props.formState.beneficiaries.filter((form, formIndex) => formIndex !== nullForms[0]);
                    const totalBene = Math.ceil(100 / props.formState.numberOfPrimaryBeneficiary);
                    var updatedBene = selectedBene.map((bene, index) => {
                        bene.percentage = totalBene
                        setValue(`beneficiaries[${index}].percentage`, totalBene);
                        return bene;
                    });
                    props.onFieldChange('beneficiaries', updatedBene);
                    setValue('beneficiaries', updatedBene);
                }
            }
            else if (numberOfForms < numberOfPrimaryBeneficiaryForms) {
                addNewBeneficiary('beneficiaries', numberOfPrimaryBeneficiaryForms - 1);
            }
        }
    }, [props.formState.numberOfPrimaryBeneficiary]);

    const getListOfPlanIncludedPerson = () => {
        var form = { ...props.fullFormState };
        const spouseFullName = `${form.steps.spouseInfo.lastName} ${form.steps.spouseInfo.firstName} ${form.steps.spouseInfo.middleInitial}`;
        const showSpouseScreenPlan = ['namedSpousePremium', 'twoParentFamilyPremium'];
        const options = [];
        if (form.steps.quoter.plan && showSpouseScreenPlan.includes(form.steps.quoter.plan)) {
            options.push({ value: "Name Of Spouse", label: spouseFullName })
        }
        return options;
    }

    useEffect(() => {
        const numberOfContBeneficiaryForms = props.formState.numberOfContBeneficiary;
        const numberOfForms = props.formState.contBeneficiaries.length;
        const nullCount = [];
        if (props.formState.numberOfContBeneficiary === ('0' || "")) {
            props.onFieldChange(
                'contBeneficiaries',
                Beneficiary.DefaultFormState().contBeneficiaries
            );
        }
        if (numberOfContBeneficiaryForms > 0) {
            if (numberOfForms > numberOfContBeneficiaryForms) {
                for (let i = 0; i < numberOfForms - numberOfContBeneficiaryForms; i++) {
                    let nullForms = props.formState.contBeneficiaries.map((beneficiaryFormState, index) => {
                        if (Object.values(beneficiaryFormState).every(field => field === '')) {
                            return index;
                        }
                    })
                    if (nullForms.length > 0) {
                        nullForms = nullForms.filter((index) => index !== undefined);
                    }
                    if (nullForms.length === 0) {
                        props.formState.contBeneficiaries.map((beneficiaryFormState, index) => {
                            const arrayValues = Object.values(beneficiaryFormState)
                            nullCount[index] = arrayValues.filter(value => value === null || value === '').length;
                            return
                        })
                    }
                    if (nullCount.length > 0) {
                        const maxVlaue = Math.max(...nullCount);
                        nullForms = [nullCount.indexOf(maxVlaue)];

                        if (nullForms.length === 0) {
                            nullForms = [parseInt(numberOfContBeneficiaryForms)];
                        }
                    }
                    props.onFieldChange(
                        'contBeneficiaries',
                        props.formState.contBeneficiaries.filter((form, formIndex) => formIndex !== nullForms[0])
                    );
                    setValue('contBeneficiaries', props.formState.contBeneficiaries.filter((form, formIndex) => formIndex !== nullForms[0]));
                }
            }
            else if (numberOfForms < numberOfContBeneficiaryForms) {
                addNewBeneficiary('contBeneficiaries', numberOfContBeneficiaryForms - 1);
            }
        }
    }, [props.formState.numberOfContBeneficiary])

    const addNewBeneficiary = (beneType, numberOfNewForm) => {

        let typeOfBeneficiary;
        let typeOfDependentChild;

        if (beneType === "beneficiaries") {
            typeOfBeneficiary = "selectPrimary";
            typeOfDependentChild = "primaryDependentChild";
        } else {
            typeOfBeneficiary = "selectContingent";
            typeOfDependentChild = "contingentDependentChild";
        }
        const newForm = [], percentageValue = Math.ceil(100 / props.formState.numberOfPrimaryBeneficiary);
        let existingBene = [...props.formState[beneType]];
        for (let i = 0; i < numberOfNewForm; i++) {
            const newBeneIndex = props.formState[beneType].length;
            setValue(`${beneType}[${newBeneIndex}].${typeOfBeneficiary}`, "New Individual");
            setValue(`${beneType}[${newBeneIndex}].${typeOfDependentChild}`, 1);
            setValue(`${beneType}[${newBeneIndex}].percentage`, percentageValue);
            const newData = Beneficiary.DefaultFormState()[beneType][0];
            if (beneType === "beneficiaries") {
                newData.percentage = percentageValue;
                if (existingBene && existingBene.length > 0) {
                    existingBene = existingBene.map((bene, index) => {
                        bene.percentage = percentageValue
                        setValue(`${beneType}[${index}].percentage`, percentageValue);
                        return bene;
                    });
                }
            }
            newForm.push(newData);
        }
        props.onFieldChange(beneType, [...existingBene, ...newForm]);
    }

    const handleSelectBeneficiary = (value, index) => {
        var form = { ...props.fullFormState };
        const { firstName, middleName, lastName, city, state, dateOfBirth, relationshipStatus } = getBeneficiaryDetails(value);
        form.steps.beneficiary.beneficiaries[index].selectPrimary = value;
        form.steps.beneficiary.beneficiaries[index].firstName = firstName ? firstName : '';
        form.steps.beneficiary.beneficiaries[index].middleInitial = middleName ? middleName : '';
        form.steps.beneficiary.beneficiaries[index].lastName = lastName ? lastName : '';
        form.steps.beneficiary.beneficiaries[index].city = city ? city : '';
        form.steps.beneficiary.beneficiaries[index].state = state ? state : '';
        form.steps.beneficiary.beneficiaries[index].dateOfBirth = dateOfBirth ? dateOfBirth : null;
        form.steps.beneficiary.beneficiaries[index].relationship = relationshipStatus ? relationshipStatus : '';

        props.onMultiFieldChange(form);
        setValue(`beneficiaries`, form.steps.beneficiary.beneficiaries);
    }

    const primaryForms = props.formState.beneficiaries.map((beneficiaryFormState, index) =>
        <BeneficiaryForm
            formState={beneficiaryFormState}
            onChange={(newForm) => {
                props.onFieldChange(
                    'beneficiaries',
                    props.formState.beneficiaries.map((form, formIndex) => {
                        return formIndex === index ? newForm : form;
                    })
                );
            }}
            trigger={trigger}
            key={index}
            index={index}
            beneType='beneficiaries'
            state={state}
            onSelectBeneficiary={handleSelectBeneficiary}
            getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
        />
    )

    const contingentForms = props.formState.contBeneficiaries.map((beneficiaryFormState, index) =>
        <BeneficiaryForm
            formState={beneficiaryFormState}
            onChange={(newForm) => {
                props.onFieldChange(
                    'contBeneficiaries',
                    props.formState.contBeneficiaries.map((form, formIndex) => {
                        return formIndex === index ? newForm : form;
                    })
                );
            }}
            trigger={trigger}
            key={index}
            index={index}
            beneType='contBeneficiaries'
            state={state}
            onSelectBeneficiary={handleSelectContingentBeneficiary}
            getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
        />
    )

    const onSubmit = () => {
        let primaryBenePercentTotal = 0;
        let contingentBenePercentTotal = 0;
        const radix = 10;

        props.formState.beneficiaries.forEach((bene, index) => {
            primaryBenePercentTotal += parseInt(bene.percentage, radix);
        });
        props.formState.contBeneficiaries.forEach((bene, index) => {
            if (bene.selectContingent !== "" && bene.selectContingent !== "None") {
                contingentBenePercentTotal += parseInt(bene.percentage, radix);
            }
        });

        setShowBeneCountMessage(false);
        setBeneCountMessage("");
        if (!primaryBenePercentTotal || primaryBenePercentTotal !== 100) {
            setShowBeneCountMessage(true);
            setBeneCountMessage("Primary beneficiary percentage must add up to 100");
            setTimeout(() => {
                if (beneErrorMessage.current) {
                    window.scrollTo({
                        top: beneErrorMessage.current.offsetTop,
                        behavior: "smooth"
                    });
                }
            }, 100);
        } else if (contingentBenePercentTotal && contingentBenePercentTotal !== 100) {
            setShowBeneCountMessage(true);
            setBeneCountMessage("Contingent beneficiary percentage must add up to 100");
            setTimeout(() => {
                if (beneErrorMessage.current) {
                    window.scrollTo({
                        top: beneErrorMessage.current.offsetTop,
                        behavior: "smooth"
                    });
                }
            }, 100);
        } else {
            props.onNext()
        }
    }

    return (
        <Container className="border-class" fluid>
            <FormProvider {...formMethods}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="justify-content-center mt-4">
                        <Col lg={5} className='w-100'>
                            <div className="text-center mb-2 pt-4"><SvgIcon component={Ring} className="small-icons" color="primary" fontSize="large" /></div>
                            <div className="text-center mb-4 form-title">Beneficiary Information</div>

                            {showBeneCountMessage && <div ref={beneErrorMessage} className="text-danger text-center mb-3">{beneCountMessage}</div>}

                            <div className='mb-3'>
                                <SelectInput
                                    name="numberOfPrimaryBeneficiary"
                                    id="numberOfPrimaryBeneficiary"
                                    value={props.formState.numberOfPrimaryBeneficiary}
                                    onChange={e => handleValueChange('numberOfPrimaryBeneficiary', e.target.value)}
                                    label="Number Of Primary Beneficiaries"
                                    selectOptions={getNumberOfBeneficiaryOptions()}
                                    hideEmptyOption={true}
                                />
                            </div>

                            {props.formState.numberOfPrimaryBeneficiary >= 1 && primaryForms}
                            <div className='mb-3'>
                                <SelectInput
                                    name="numberOfContBeneficiary"
                                    id="numberOfContBeneficiary"
                                    value={props.formState.numberOfContBeneficiary}
                                    onChange={e => handleValueChange('numberOfContBeneficiary', e.target.value)}
                                    label="Number of Contingent Beneficiaries"
                                    selectOptions={getNumberOfBeneficiaryOptions(true)}
                                    hideEmptyOption={true}
                                />
                            </div>

                            {props.formState.numberOfContBeneficiary >= 1 && contingentForms}
                        </Col>
                    </Row>
                    <div className='backnext-wrapper'>
                        <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} />
                    </div>
                </Form>
            </FormProvider>
        </Container>
    );
}

Beneficiary.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

Beneficiary.ValidationSchema = (insuredAge, state) => {
    return object().shape({
        numberOfPrimaryBeneficiary:
            string().required("Number Of Primary Beneficiary is required."),
        beneficiaries: mixed().when(
            'numberOfPrimaryBeneficiary',
            (numberOfPrimaryBeneficiary, schema) => {
                if (state === MARYLAND && numberOfPrimaryBeneficiary > 0) {
                    return yuparray(object().shape({
                        selectPrimary: string().required("Primary Beneficiary is required."),
                        primaryDependentChild: yupnumber().when('selectPrimary', {
                            is: "Name(s) of Dependent Child(ren)",
                            then: (schema) => schema.required("Dependent child is required."),
                            otherwise: (schema) => schema.notRequired()
                        }),
                        firstName: customValidators.string().when('selectPrimary', {
                            is: (selectPrimary) => selectPrimary === "New Individual",
                            then: (schema) => schema
                                .isValidNameWithFiftyChar('First Name is required.', true),
                            otherwise: (schema) => schema.notRequired()
                        }),
                        lastName: customValidators.string().when('selectPrimary', {
                            is: (selectPrimary) => selectPrimary === "New Individual",
                            then: (schema) => schema
                                .isValidNameWithFiftyChar('Last Name is required.', true),
                            otherwise: (schema) => schema.notRequired()
                        }),
                        middleInitial: customValidators.string().when('selectPrimary', {
                            is: (selectPrimary) => selectPrimary === "New Individual",
                            then: (schema) => schema.isValidNameWithFiftyChar('Middle Initials is required', true),
                            otherwise: (schema) => schema.notRequired()
                        }),
                        dateOfBirth: date().when(
                            ['selectPrimary', 'relationship'],
                            ([selectPrimary, relationship], schema) => {
                                if (selectPrimary === "New Individual" && (relationship === "Child" || relationship === "Grandchild" || relationship === "Step Child")) {
                                    return schema
                                        .transform(emptyStringToUndefined)
                                        .typeError('Invalid date.')
                                        .max(moment(new Date()), 'Cannot be in future.').required("Date of Birth is required.")
                                        .min(sub(new Date(), { years: insuredAge + 1 }), `Child's age cannot be greater than parent.`)
                                }
                                return date().when('selectPrimary', {
                                    is: (selectPrimary) => selectPrimary === "New Individual",
                                    then: (schema) => schema
                                        .transform(emptyStringToUndefined)
                                        .typeError('Invalid date.')
                                        .max(moment(new Date()), 'Cannot be in future.').required("Date of Birth is required."),
                                    otherwise: (schema) => schema.notRequired().nullable()
                                })
                            }
                        ),
                        relationship: string().when('selectPrimary', {
                            is: (selectPrimary) => selectPrimary === "New Individual",
                            then: (schema) => schema.required("Relationship is required."),
                            otherwise: (schema) => schema.notRequired()
                        }),
                        percentage: yupnumber()
                            .typeError('Percentage is required.')
                            .transform(emptyStringToUndefined)
                            .min(1)
                            .max(100, 'Percentage must be between 1 and 100.')
                            .required('Percentage is required.')
                    }))
                }
                return mixed().when(
                    'numberOfPrimaryBeneficiary',
                    (numberOfPrimaryBeneficiary, schema) => {
                        if (state === VIRGIN_ISLANDS && numberOfPrimaryBeneficiary > 0) {
                            return yuparray(object().shape({
                                selectPrimary: string().required("Primary Beneficiary is required."),
                                primaryDependentChild: yupnumber().when('selectPrimary', {
                                    is: "Name(s) of Dependent Child(ren)",
                                    then: (schema) => schema.required("Dependent child is required."),
                                    otherwise: (schema) => schema.notRequired()
                                }),
                                firstName: customValidators.string().when('selectPrimary', {
                                    is: "New Individual",
                                    then: (schema) => schema
                                        .isValidNameWithFiftyChar('First Name is required.', true),
                                    otherwise: (schema) => schema.notRequired()
                                }),
                                lastName: customValidators.string().when('selectPrimary', {
                                    is: (selectPrimary) => selectPrimary === "New Individual",
                                    then: (schema) => schema
                                        .isValidNameWithFiftyChar('Last Name is required.', true),
                                    otherwise: (schema) => schema.notRequired()
                                }),
                                middleInitial: customValidators.string().when('selectPrimary', {
                                    is: (selectPrimary) => selectPrimary === "New Individual",
                                    then: (schema) => schema.isValidNameWithFiftyChar('Middle Initials is required', false),
                                    otherwise: (schema) => schema.notRequired()
                                }),
                                dateOfBirth: date().when(
                                    ['selectPrimary', 'relationship'],
                                    ([selectPrimary, relationship], schema) => {
                                        if (selectPrimary === "New Individual" && (relationship === "Child" || relationship === "Grandchild" || relationship === "Step Child")) {
                                            return schema
                                                .transform(emptyStringToUndefined)
                                                .typeError('Invalid date.')
                                                .max(moment(new Date()), 'Cannot be in future.').required("Date of Birth is required.")
                                                .min(sub(new Date(), { years: insuredAge + 1 }), `Child's age cannot be greater than parent.`)
                                        }
                                        return date().when('selectPrimary', {
                                            is: (selectPrimary) => selectPrimary === "New Individual",
                                            then: (schema) => schema
                                                .transform(emptyStringToUndefined)
                                                .typeError('Invalid date.')
                                                .max(moment(new Date()), 'Cannot be in future.').required("Date of Birth is required."),
                                            otherwise: (schema) => schema.notRequired().nullable()
                                        })
                                    }
                                ),
                                relationship: string().when('selectPrimary', {
                                    is: (selectPrimary) => selectPrimary === "New Individual",
                                    then: (schema) => schema.required("Relationship is required."),
                                    otherwise: (schema) => schema.notRequired()
                                }),
                                percentage: yupnumber()
                                    .typeError('Percentage is required.')
                                    .transform(emptyStringToUndefined)
                                    .min(1)
                                    .max(100, 'Percentage must be between 1 and 100.')
                                    .required('Percentage is required.'),
                                city: string().required("City is required."),
                                state: string().required("State is required.")
                            }))
                        }
                        return schema.notRequired()
                    })
            })
    })
};

Beneficiary.DefaultFormState = (prefill = false) => {
    return {
        numberOfPrimaryBeneficiary: 1,
        beneficiaries: [
            {
                selectPrimary: 'New Individual',
                primaryDependentChild: 1,
                firstName: '',
                middleInitial: '',
                lastName: '',
                dateOfBirth: null,
                relationship: '',
                city: '',
                state: '',
                percentage: 100,
            }
        ],
        numberOfContBeneficiary: 0,
        contBeneficiaries: [
            {
                selectContingent: '',
                contingentDependentChild: 1,
                firstName: '',
                middleInitial: '',
                lastName: '',
                dateOfBirth: null,
                relationship: '',
                city: '',
                state: '',
                percentage: null,
            }
        ],
    };
};
